import { render, staticRenderFns } from "./Barbican.vue?vue&type=template&id=1adcfd68&"
import script from "./Barbican.vue?vue&type=script&lang=js&"
export * from "./Barbican.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports